let ClaimTypes = require('../Data/ClaimTypes');

module.exports = {
    add: function(typeId, value, month, year, guid = undefined) {
        // get the current previous claims
        let previousClaims = JSON.parse(window.localStorage.getItem('previous_claims'));

        // if we dont have any, its an object
        if (previousClaims == undefined) {
            previousClaims = {};
        }

        // if dont have a guid, generate a new one
        if (guid == undefined) {
            guid = window.guid();
        }

        // setup and add the previous claim
        let previousClaim = {
            "type" : typeId,
            "value" : value,
            "month" : month,
            "year" : year,
        };
        previousClaims[guid] = previousClaim;

        window.localStorage.setItem('previous_claims', JSON.stringify(previousClaims));

        return previousClaims;
    },
    edit: function(guid, typeId, value, month, year) {
        if (guid == undefined) {
            throw ("Trying to edit without a guid");
        }

        this.delete(guid);
        this.add(typeId, value, month, year, guid);

        return JSON.parse(window.localStorage.getItem('previous_claims'));
    },
    delete: function(guid) {
        // get the current previous claims
        let previousClaims = JSON.parse(window.localStorage.getItem('previous_claims'));

        // if we havent got any, theres nothing to delete
        if (previousClaims == undefined) {
            return false;
        }

        delete previousClaims[guid];

        window.localStorage.setItem('previous_claims', JSON.stringify(previousClaims));

        return previousClaims;
    },
    deleteAll : function() {
        window.localStorage.removeItem('previous_claims');
        return true;
    },
    get: function() {
        let t = window.localStorage.getItem('previous_claims');
        if (t === undefined) {
            return null;
        }
        return JSON.parse(t);
    },
    getTypeStringForId : (id) => {
        let name = '';
        window.$.each(ClaimTypes.default, (i, e) => {
            if (e.value == id) {
                name = e.name;
            }
        });
        return name;
    }
};



/** WEBPACK FOOTER **
 ** ./src/components/Managers/Claim.js
 **/